<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.class}`"
        class=""
        :data-type="context.type"
    >
        <div v-html="content" :class="contentClass"></div>
    </div>
</template>

<script>

// This is intended to just display static HTML content, not Vue components
// should only be used with trusted content since it uses v-html directive
// useful for situations where you need to render HTML on backend, cannot use normal Formulate Schema

export default {
    name: 'FormulateHtmlContent',
    components: {},
    mixins: [
    ],
    props: {
        context: {  // the required Formulate context prop
            type: Object,
            required: true,
        },
        content: {  // HTML content, as a string 
            type: String,
            default: '',
        },
        contentClass: {
            type: [Array, String],
            default: '',
        },
    },
    data: function() {
        return {}
    },
    computed: {

    },
    mounted: function() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

    }
}
</script>

<style lang="scss" scoped>

</style>